var map = {
	"./step_1.png": 9222,
	"./step_1_active.png": 7435,
	"./step_2.png": 6921,
	"./step_2_active.png": 7004,
	"./step_3.png": 9787,
	"./step_3_active.png": 4693,
	"./step_4.png": 5732,
	"./step_4_active.png": 1224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;